module.exports = __webpack_public_path__ + "img/IMG_9257_T_L_Black.7cfb88cb.jpg";